// libs
import styled from 'styled-components'

export const DocOrLinkWrapper = styled.div<{ $isForm: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: ${({ $isForm }) => ($isForm ? 'center' : 'flex-start')};
  min-width: 0;
`

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  user-select: none;
`
